import React from 'react'
import {
  BrowserRouter,
  Routes,
  Route,
  Navigate 
} from "react-router-dom";

import FaqHome from './pages/FaqHome.js';
import PrivacyHome from './pages/PrivacyHome.js';
import TermsHome from './pages/TermsHome.js';

import FaqMall from './pages/FaqMall.js';
import FaqStrukReject from './pages/FaqStrukReject.js';
import FaqStrukApprove from './pages/FaqStrukApprove.js';
import PrivacyMall from './pages/PrivacyMall.js';
import TermsMall from './pages/TermsMall.js';

import FaqPradita from './pages/FaqPradita.js';
import PrivacyPradita from './pages/PrivacyPradita.js';
import TermsPradita from './pages/TermsPradita.js';

import FaqWellground from './pages/FaqWellground.js';
import PrivacyWellground from './pages/PrivacyWellground.js';
import TermsWellground from './pages/TermsWellground.js';
import GlobalConfig from "./GlobalConfig.js";

import Home from './pages/Home.js'
import StoreRedirect from './components/StoreRedirect.js';
import FaqDownToGreen from './pages/FaqDownToGreen.js';
import FaqRegisterKtp from './pages/FaqRegisterKtp.js';
import {
  FaqV2, 
  FaqV2DetailBayarTagihan,
  FaqV2DetailLotReserveParking, 
  FaqV2DetailPermitAndReport,
  FaqV2DetailAccessProperty,
  FaqV2DetailExpiredStamp,
  FaqV2DetailValidasiKTP,
  MembershipV2,
  FaqV2DetailFaq
} from './pages/Index.js';

const WELLGROUND_APP_STORE = 'https://apps.apple.com/us/app/wellground/id6747055551';
const WELLGROUND_PLAY_STORE = 'https://play.google.com/store/apps/details?id=com.wellground&hl=en';

const HOME_APP_STORE = 'https://apps.apple.com/id/app/summarecon-home/id1584050086';
const HOME_PLAY_STORE = 'https://play.google.com/store/apps/details?id=com.summareconhome&hl=id';

const MALL_APP_STORE = 'https://apps.apple.com/id/app/summarecon-mall/id1564420394';
const MALL_PLAY_STORE = 'https://play.google.com/store/apps/details?id=com.summareconmall';

const baseName = () => {
  let baseName = "/landingpage";
  try {
    if (GlobalConfig.BASE_NAME == "PROD"){
      baseName = "/";
    }
    return baseName;
  } catch (error) {
    return baseName;
  }
};

function App() {
  return (
    <BrowserRouter basename={baseName()}>
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="mall/faq" element={<FaqMall />} />
      <Route path="mall/privacy-policy" element={<PrivacyMall />} />
      <Route path="mall/terms-conditions" element={<TermsMall />} />
      <Route
        path="mall/links/*"
        element={
          <StoreRedirect appStoreUrl={MALL_APP_STORE} playStoreUrl={MALL_PLAY_STORE} />
        }
      />
      <Route path="home/faq" element={<FaqHome />} />
      <Route path="home/privacy-policy" element={<PrivacyHome />} />
      <Route path="home/terms-conditions" element={<TermsHome />} />
      <Route
        path="home/links/*"
        element={
          <StoreRedirect appStoreUrl={HOME_APP_STORE} playStoreUrl={HOME_PLAY_STORE} />
        }
      />
      <Route path="pradita/faq" element={<FaqPradita />} />
      <Route path="pradita/privacy-policy" element={<PrivacyPradita />} />
      <Route path="pradita/terms-conditions" element={<TermsPradita />} />
       <Route path="wellground/faq" element={<FaqWellground />} />
      <Route path="wellground/privacy-policy" element={<PrivacyWellground />} />
      <Route path="wellground/terms-conditions" element={<TermsWellground />} />
      <Route
        path="wellground/links/*"
        element={
          <StoreRedirect appStoreUrl={WELLGROUND_APP_STORE} playStoreUrl={WELLGROUND_PLAY_STORE} />
        }
      />
      <Route path="*" element={<Navigate replace to="/" />} />

      {/* V2 */}
      <Route path="v2/faq">
        <Route index element={<FaqV2 />} />
        <Route path="lot-reserve-parking" element={<FaqV2DetailLotReserveParking />} />
        <Route path="struk-reject" element={<FaqStrukReject />} />
        <Route path="struk-approve" element={<FaqStrukApprove />} />
        <Route path="down-to-green" element={<FaqDownToGreen />} />
        <Route path="register-ktp" element={<FaqRegisterKtp />} />
        <Route path="payment" element={<FaqV2DetailBayarTagihan />} />
        <Route path="permit-report" element={<FaqV2DetailPermitAndReport />} />
        <Route path="access-property" element={<FaqV2DetailAccessProperty />} />
        <Route path="expired-stamp" element={<FaqV2DetailExpiredStamp />} />
        <Route path="validasi-ktp" element={<FaqV2DetailValidasiKTP />} />
        <Route path="detail/:id" element={<FaqV2DetailFaq />} />
      </Route>
      <Route path="v2/membership">
        <Route index element={<MembershipV2 />} />
      </Route>

    </Routes>
  </BrowserRouter>
    
  );
}

export default App;
